import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ListingService } from '@app/core/services/listing.service';
import { ImageUtil } from '@app/shared/utils/image.util.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  formValues = null;
  currencies: string[] = null;
  // Single date picker
  date = new FormControl(new Date());
  propsSDP: any;
  formSRP: any;
  today = new Date();
  maxDateForPicker = new Date(new Date().setFullYear(new Date().getFullYear() + 3));
  startDate: Date;
  endDate;
  pickerMinDate2;
  selectedDate: Date;
  selectedDateAdv: Date;
  dateRangePickerProps: any;
  formDateRangePickerProps: any;
  selectedDateRange: any;
  listingDetails: any;
  dates = {
    minDate: null,
    maxDate: null,
    fromDate: null,
    toDate: null
  };
  reservedDates: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private listingService: ListingService,
    private notifier: NotifierService,
    private imageUtil: ImageUtil
  ) {
    // Single date picker conf
    this.propsSDP = {
      startDatePlaceholderText: 'Available From',
      endDatePlaceholderText: 'Available To',
      required: true,
      keepOpenOnDateSelect: true,
      focusedInput: 'startDate'
    };
    this.dateRangePickerProps = Object.assign({}, this.propsSDP);

    this.formSRP = {
      startDatePlaceholderText: 'Start Date',
      endDatePlaceholderText: 'Return Date',
      required: true
    };
    this.formDateRangePickerProps = Object.assign({}, this.formSRP);
  }

  ngOnInit() {
    this.currencies = ['SGD', 'USD', 'EU', 'JPY', 'PHP'];
    this.route.data.subscribe(data => {
      console.log('data', data.listingDetails);
      this.listingDetails = data.listingDetails;
      const startDate = new Date(this.listingDetails.startDate.toDate());
      // this.dates.minDate = new Date() < startDate ? startDate : new Date();
      this.dates.minDate = startDate;
      this.startDate = startDate;
      this.pickerMinDate2 = startDate > this.today ? startDate : this.today;
      this.dates.fromDate = this.dates.minDate;
      this.dates.maxDate = new Date(this.listingDetails.endDate.toDate());
      this.endDate = this.dates.maxDate > this.today ? this.dates.maxDate : null;
      this.selectedDate = this.dates.maxDate;
      this.listingService.getRents(data.listingDetails.id).subscribe(rents => {
        this.reservedDates = rents;
      });
      this.formValues = this.formBuilder.group({
        startDate: [startDate, Validators.required],
        endDate: [this.endDate, Validators.required],
        currency: [this.listingDetails.currency, Validators.required],
        rentalPrice: [this.listingDetails.rentalPrice, Validators.required],
        description: [this.listingDetails.description, Validators.required],
        location: [this.listingDetails.location, Validators.required],
        name: [this.listingDetails.name, Validators.required]
      });
    });
  }

  resetValues(event) { }

  async updateListing(itemID) {
    const doc = {
      startDate: this.formValues.controls.startDate.value,
      endDate: this.formValues.controls.endDate.value,
      currency: this.formValues.controls.currency.value,
      rentalPrice: this.formValues.controls.rentalPrice.value,
      description: this.formValues.controls.description.value,
      location: this.formValues.controls.location.value,
      name: this.formValues.controls.name.value
    };
    try {
      const result = await this.listingService.updateListing(itemID, doc);
      this.notifier.notify('success', 'Your Item has been Updated');
      this.router.navigate(['profile/my-listing']);
    } catch (e) { }
  }

  changeDateRangeCal1(event) {
    console.log('changeDateRangeCal1 event', event);
  }

  onDate(event): void {
    const tomorrow = new Date(event.value.setDate(event.value.getDate() + 1));
    if (this.endDate < tomorrow) {
      this.endDate = null;
    }
    this.pickerMinDate2 = tomorrow;
  }

  getBackgroundImageStyle(imageUrl: string) {
    return this.imageUtil.getBackgroundImageStyle(imageUrl);
  }
}
